export interface IBaseballNpbState {
  isShow: boolean;
  games?: Array<{
    url: string;
    teamHome: string;
    teamVisitor: string;
  }>;
  date?: string;
}
const initialState: IBaseballNpbState = {
  isShow: false
};
export default (state: IBaseballNpbState = initialState) => {
  return state;
};
